import * as React from 'react';

//components
import { ErrorScreen } from 'common/pages/ErrorPages';
//config
import configuration from 'configs/configuration';
//services
import * as Logger from 'services/logger';

class ErrorBoundary extends React.Component {
  state = {
    error: null,
  };

  componentDidCatch(error, errorInfo) {
    this.setState({ error });

    if (configuration.isProduction) {
      Logger.captureException(error, {
        tags: [`hostname:${window.location.hostname}`],
        customData: errorInfo,
      });
    } else {
      // eslint-disable-next-line no-console
      console.log('ERROR', error);
    }
  }

  render() {
    const { error } = this.state;
    const { children } = this.props;

    if (error) {
      return <ErrorScreen />;
    } else {
      return children;
    }
  }
}

export default ErrorBoundary;
